module.exports = __webpack_public_path__ + "static/img/pl.57dd39e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/pl.png
// module id = 6QQj
// module chunks = 18